import { Flex, Text, Textarea } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { NoteIcon } from "../../styles/icons/NoteIcon";


type observationProps = {
    setObservationText: React.Dispatch<React.SetStateAction<string>>;
    observationText: string;
    onEdit: Boolean;
}

export function ObservationTextSection({ setObservationText, observationText, onEdit }: observationProps) {

    const { email } = JSON.parse(localStorage.getItem("barte-user-info"))
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000); 

        return () => clearInterval(interval); 
    }, []);

    const formattedDate = currentTime.toLocaleDateString("pt-BR"); 
    const formattedTime = currentTime.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });


    return (
        <Flex
            flexDirection="column"
            gap="24px"
        >
            <Flex gap="8px" alignItems="center">
                <NoteIcon />
                <Text
                    fontSize="20px"
                    fontFamily="Hero New"
                    fontWeight="600"

                >
                    Observações
                </Text>
            </Flex>
            <Flex flexDirection="column" w="1121px">
                <Text
                    as="span"
                    m="10px 0 0 17px"
                    fontSize="12px"
                    fontFamily='Hero New'
                    fontWeight="bold"
                    color="rgba(138, 148, 168, 1)"
                    position="absolute">
                  {formattedDate} - {formattedTime} - {email}
                </Text>
                <Textarea
                    h="96px"
                    paddingTop="30px"
                    maxLength={99}
                    value={observationText}
                    placeholder="Digite aqui..."
                    _placeholder={{ color: "gray.400" }}
                    onChange={(e) => setObservationText(e.target.value)}
                    isDisabled={!onEdit}
                />

            </Flex>

        </Flex>
    );
}

